export const base_url = "https://wordaddin.educating.ai"
// export const base_url = "https://dassadas.fsdfafs.ai"

// export const base_url = "https://37cf448022a4.ngrok-free.app"
